/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyReturnBill from './pharmacy-return-bill';
import PharmacyReturnBillDetail from './pharmacy-return-bill-detail';
import PharmacyReturnBillUpdate from './pharmacy-return-bill-update';
import PharmacyReturnBillDeleteDialog from './pharmacy-return-bill-delete-dialog';

const PharmacyReturnBillRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyReturnBill />} />
    <Route path="new" element={<PharmacyReturnBillUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyReturnBillDetail />} />
      <Route path="edit" element={<PharmacyReturnBillUpdate />} />
      <Route path="delete" element={<PharmacyReturnBillDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyReturnBillRoutes;
